import React from 'react';
import { EntityTaskDetails } from 'components/common/tasks/entityTaskDetails';

export const ClientTaskDetails = () => {
  return <EntityTaskDetails entityName={'CLIENT'} />;
};
